import {LoaderFunctionArgs} from 'react-router-dom';
import {getRootStore} from '../../app.bootstrap';
import {getAppTracer} from '../../../app.tracer';
import {RouteName} from '../../router/route-names';
import {PromiseUtilsService} from '@techsee/techsee-client-services/lib/services/PromiseUtilsService';
import {sendSentryLog} from '../../../error-reporting';

const trace = getAppTracer('reactivate-account.loader');

export async function reactivateAccountRouteLoader(args: LoaderFunctionArgs): Promise<void> {
    const rootStore = getRootStore();
    const url = new URL(args.request.url);
    const authId = url.searchParams.get('authId') ?? undefined;
    const orgId = url.searchParams.get('orgId') ?? undefined;
    const emb = url.searchParams.get('emb') ?? undefined;
    const mini = url.searchParams.get('mini') ?? undefined;

    try {
        trace.info('Starting');
        await PromiseUtilsService.startPromiseWithTimeout(() => trace.info('Loaded', {authId}), 3000);
        await rootStore.accountService.sendReactivationDetails(orgId as string);
        await rootStore.tsReactStateHelper.navigateTo(RouteName.INVITE, {authId, emb, mini});
    } catch (err) {
        if (err instanceof Response) throw err;
        const traceMessage = `Failed to redirect from sso-action (Auth=${authId}): ${err}`;
        await PromiseUtilsService.startPromiseWithTimeout(() => trace.error(traceMessage, err), 3000).catch(
            (traceErr) => console.error(traceMessage + ' >> trace failed: ' + traceErr)
        );
        sendSentryLog(err);
        await rootStore.tsReactStateHelper.navigateTo(RouteName.EMB_DASHBOARD_ERROR);
    }
}
